export const iconFontAwesomeMediaplaybackPhoneVolume = (
	<i className="fa-solid fa-phone-volume"></i>
);
